import reqest from "../common/reqest";


/**
 * 观展预约列表导出
 */
export function SubscribeGzExport(data) {
  return reqest.export("/LiveOperation/Subscribe_List_Gz_export", data)
}


/**
 * 观展记录列表导出
 */
export function GzRecordExport(data) {
  return reqest.export("/LiveOperation/Gz_Record_Export", data)
}
/**
 * 参展记录列表导出
 */
export function CzRecordExport(data) {
  return reqest.export("/LiveOperation/Cz_Record_Export", data)
}
